import Vue from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);
import Login from '../../../Components/Auth/Login.vue';

new Vue({
    components: {
        Login
    },
    el: '#app',
    data() {
        return {
        }
    },
    methods: {
    }
});


// WEBPACK FOOTER //
// ./Scripts/js/accounts/login.js